import {
  UPDATE_CANDIDATE_RATING_REQUEST,
  UPDATE_CANDIDATE_RATING_SUCCESS,
  UPDATE_CANDIDATE_RATING_FAILURE,
  RESET_CANDIDATE_RATING_MESSAGE,
} from "../../actionTypes";

const initialState = {
  status: false,
  isLoading: false,
  message: "",
};

const updateCandidateRatingReducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_CANDIDATE_RATING_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case UPDATE_CANDIDATE_RATING_SUCCESS:
      console.log("us", action.payload);
      return {
        ...state,
        isLoading: false,
        status: action.payload.status,
        message: action.payload.message,
      };
    case UPDATE_CANDIDATE_RATING_FAILURE:
      return {
        ...state,
        isLoading: false,
        status: action.payload.status,
        message: action.payload.message,
      };
    case RESET_CANDIDATE_RATING_MESSAGE:
      return {
        ...state,
        status: false,
        isLoading: false,
        message: "",
      };
    default:
      return state;
  }
};

export default updateCandidateRatingReducer;
